import { useState, useEffect } from "react";
import { useFetcher } from "@remix-run/react";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Stack,
  Text,
} from "@chakra-ui/react";

export function FacilityRequestModal({
  isOpen,
  onClose,
  query,
  agencyId,
  user,
}) {
  const [key, setKey] = useState(0);
  const fetcher = useFetcher({ key: `facility-request-${key}` });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (fetcher.data?.success) setSubmitted(true);
  }, [fetcher.data]);

  const handleClose = () => {
    setSubmitted(false);
    setKey((k) => k + 1);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Suggest a spot</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {submitted ? (
            <Stack spacing={4}>
              <Alert status="success" borderRadius="md">
                <AlertIcon />
                <Stack spacing={0}>
                  <AlertTitle>Thanks for the suggestion!</AlertTitle>
                  <AlertDescription>
                    We'll look into adding this spot to our database.
                  </AlertDescription>
                </Stack>
              </Alert>
              <Button onClick={handleClose} variant="outline" size="sm">
                Close
              </Button>
            </Stack>
          ) : (
            <Stack
              as={fetcher.Form}
              method="post"
              action="/api/facility-request"
              spacing={4}
            >
              {agencyId && (
                <input type="hidden" name="agencyId" value={agencyId} />
              )}
              {fetcher.data?.error && (
                <Alert status="error" borderRadius="md">
                  <AlertIcon />
                  <AlertDescription>{fetcher.data.error}</AlertDescription>
                </Alert>
              )}
              <Text>
                Can't find what you're looking for? Suggest a park or campground
                and we'll look into adding it.
              </Text>
              <FormControl>
                <FormLabel>Park or campground name</FormLabel>
                <Input name="query" defaultValue={query} />
              </FormControl>
              {!user && (
                <FormControl>
                  <FormLabel>Email (optional)</FormLabel>
                  <Input
                    name="email"
                    type="email"
                    placeholder="your@email.com"
                  />
                </FormControl>
              )}
              <Button
                type="submit"
                colorScheme="brand"
                isLoading={fetcher.state === "submitting"}
              >
                Suggest this spot
              </Button>
            </Stack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
